import video from '../assets/video.png'
import oval from '../assets/Oval.png'
import play from '../assets/play.png'
import { motion } from 'framer-motion'

const Choice = () => {
    return (
        <motion.div 
            id='about' 
            className="flex flex-col items- py-20 px-8 tab:px-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }} 
            variants={{
                hidden: { opacity: 0, y: 75 },
                visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, delay: 0.3 }}
        >

            <div className="flex tab:flex-col justify-between mb-12">

                <h2 className="text-white text-4xl font-bold">
                    Why Enver Is The Best Choice?
                </h2>

                <p 
                    className="text-greys text-lg tab:mt-7"
                >
                    Watch this one minute video so you understand why you should use our services!
                </p>

            </div>

            <div className='relative flex items-center justify-center w-full'>
                <img 
                    src={video} 
                    alt="video" 
                    className='w-[900px] object-cover'
                />

                <img 
                    src={oval} 
                    alt="oval" 
                    className='max-w-full w-20 tab:w-14 absolute cursor-pointer'
                />

                <img 
                    src={play} 
                    alt="oval" 
                    className='max-w-full w-4 tab:w-3 absolute cursor-pointer'
                />
            </div>
        </motion.div>
    );
}
 
export default Choice;